import React from "react";
import { Input } from "antd";
import { AN_MONO } from "../../../../design-system/tokens";
import { card, PanelHead, FieldLabel } from "../sshProxyUi";
import { DEFAULT_LISTEN_PORT } from "../sshProxyModel";

// Step 1 — Register.
// Creates the did.jump_server row the proxy claims on first start. Just a name
// and an address: domain is defaulted server-side, region has a DB default that
// nothing reads, and the backend allowlist is a gateway SETTING rather than a
// registration field — it lives on the gateway's Targets tab, where it can be
// changed after the proxy is running.
export default function Step1JumpHost({ state, patch, jumpServerId }) {
  const created = !!jumpServerId;

  return (
    <div style={{ display: "grid", gap: 16 }}>
      <div style={{ ...card, padding: 18 }}>
        <PanelHead
          eyebrow="Step 1 · Jump host"
          title="Register the gateway"
          desc="These fields create the record the gateway claims on first start. There is no DNS behind the name — the gateway is identified by the id returned here."
        />

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
          <label>
            <FieldLabel required>Gateway name</FieldLabel>
            <Input
              value={state.proxyName}
              onChange={(e) => patch({ proxyName: e.target.value })}
              placeholder="prod-bastion"
              disabled={created}
              style={{ height: 36 }}
            />
          </label>
          <label>
            {/* Behind NAT this is not the machine's own IP — it is whatever
                operators put in their connect command. */}
            <FieldLabel required>Address operators connect to</FieldLabel>
            <Input
              value={state.publicIp}
              onChange={(e) => patch({ publicIp: e.target.value })}
              placeholder="prod-bastion.acme.com or 203.0.113.10"
              disabled={created}
              style={{ height: 36, fontFamily: AN_MONO }}
            />
          </label>
        </div>

        <div style={{ marginTop: 14, maxWidth: 220 }}>
          <FieldLabel>Listen port</FieldLabel>
          <Input value={state.listenPort ?? DEFAULT_LISTEN_PORT} disabled style={{ height: 36, fontFamily: AN_MONO }} />
        </div>
      </div>

    </div>
  );
}
